import { Checkbox, Empty, message, Tag, Timeline, Tooltip } from "antd";
import { CheckCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, ModalItem, SegmentedItem } from "../../../../../Components/Items";
import DynamicCardForm from "../../../../../Components/DynamicCardForm";

moment.locale("es");

const OPCIONES_AVANCE = [
  { label: "Pendiente", value: 1 },
  { label: "En proceso", value: 2 },
  { label: "Terminado", value: 3 },
];

const ETIQUETA_ESTADO = {
  0: { texto: "Cancelada", color: "red" },
  1: { texto: "Abierta", color: "blue" },
  2: { texto: "En proceso", color: "orange" },
  3: { texto: "Terminada", color: "green" },
};

const COLOR_PUNTO = {
  alta: "blue",
  avance: "green",
  disponibilidad: "gray",
  edicion: "gray",
  terminar: "green",
  reabrir: "orange",
  cancelar: "red",
};

/*
  El seguimiento es lo que este módulo aporta: cada cambio se manda como un POST puntual
  (no se reenvía el documento completo) para que dos personas en piso puedan mover
  materiales distintos sin pisarse.
*/
class SeguimientoOrdenDeMaquila extends Component {
  state = {
    loading: false,
    ordenDeMaquila: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) this.consultarOrden();
  }

  consultarOrden() {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeMaquila/datosOrdenDeMaquila",
        { empresaId: this.props.empresaId, ordenDeMaquilaId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ ordenDeMaquila: res.data });
        } else {
          message.error("No se pudo cargar la orden de maquila");
          this.cerrar(false);
        }
      });
  }

  cambiarAvance(materialId, avance) {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeMaquila/cambiarAvanceMaterial",
        { empresaId: this.props.empresaId, ordenDeMaquilaId: this.props.id, materialId, avance },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.hayCambios = true;
          this.consultarOrden();
        } else {
          this.setState({ loading: false });
          message.error(res.data.message || "No se pudo cambiar el avance");
        }
      });
  }

  cambiarEstatus(materialId, campo, valor) {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeMaquila/cambiarEstatusMaterial",
        { empresaId: this.props.empresaId, ordenDeMaquilaId: this.props.id, materialId, campo, valor },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.hayCambios = true;
          this.consultarOrden();
        } else {
          this.setState({ loading: false });
          message.error(res.data.message || "No se pudo cambiar el estatus del material");
        }
      });
  }

  cambiarEstadoOrden(endpoint, exito) {
    this.setState({ loading: true });
    axios
      .post(
        `ordenesDeMaquila/${endpoint}`,
        { empresaId: this.props.empresaId, ordenDeMaquilaId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success(exito);
          this.hayCambios = true;
          this.consultarOrden();
        } else {
          this.setState({ loading: false });
          message.error(res.data.message || "No se pudo actualizar la orden");
        }
      });
  }

  cerrar(recargar = true) {
    const hubo = !!this.hayCambios;
    this.hayCambios = false;
    this.setState({ ordenDeMaquila: null });
    this.props.onCerrar(recargar && hubo);
  }

  render() {
    const { ordenDeMaquila } = this.state;
    const estado = ordenDeMaquila?.estado;
    const bloqueada = estado === 0;
    const etiquetaEstado = ETIQUETA_ESTADO[estado] || { texto: "—", color: "default" };

    return (
      <ModalItem
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span>Seguimiento {ordenDeMaquila?.folio || ""}</span>
            <Tag color={etiquetaEstado.color}>{etiquetaEstado.texto}</Tag>
          </div>
        }
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrar()}
        width={window.innerWidth > 1200 ? "70%" : "95%"}
        paddingTop
      >
        {ordenDeMaquila && (
          <>
            {bloqueada && (
              <div style={{ marginBottom: 12, color: "#cf1322", fontSize: 13 }}>
                Esta orden está cancelada. Reábrela para poder seguir moviendo materiales.
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 12 }}>
              {estado === 3 || estado === 0 ? (
                <ButtonItem
                  type="default"
                  naranja
                  icon={<ReloadOutlined />}
                  onClick={() => this.cambiarEstadoOrden("reabrirOrdenDeMaquila", "Se reabrió la orden")}
                >
                  Reabrir
                </ButtonItem>
              ) : (
                <ButtonItem
                  type="primary"
                  lima
                  icon={<CheckCircleOutlined />}
                  onClick={() => this.cambiarEstadoOrden("terminarOrdenDeMaquila", "Orden terminada")}
                >
                  Marcar Terminada
                </ButtonItem>
              )}
            </div>

            {(ordenDeMaquila.materiales || []).length === 0 && (
              <Empty description="Esta orden no tiene materiales capturados" />
            )}

            {(ordenDeMaquila.materiales || []).map((material, indice) => (
              <DynamicCardForm
                key={material._id}
                title={`Material #${indice + 1}${material.material ? ` · ${material.material}` : ""}`}
                marginBottom={12}
                compact
              >
                <div style={{ display: "flex", flexWrap: "wrap", gap: 16, alignItems: "center" }}>
                  <SegmentedItem
                    options={OPCIONES_AVANCE}
                    value={material.avance || 1}
                    disabled={bloqueada}
                    onChange={(valor) => this.cambiarAvance(material._id, valor)}
                  />
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 14 }}>
                    <Checkbox
                      checked={!!material.enPiso}
                      disabled={bloqueada}
                      onChange={(e) => this.cambiarEstatus(material._id, "enPiso", e.target.checked)}
                    >
                      En piso
                    </Checkbox>
                    <Checkbox
                      checked={!!material.enCompra}
                      disabled={bloqueada}
                      onChange={(e) => this.cambiarEstatus(material._id, "enCompra", e.target.checked)}
                    >
                      Compra
                    </Checkbox>
                    <Checkbox
                      checked={!!material.enEsperaCliente}
                      disabled={bloqueada}
                      onChange={(e) => this.cambiarEstatus(material._id, "enEsperaCliente", e.target.checked)}
                    >
                      En espera del cliente
                    </Checkbox>
                  </div>
                </div>

                <div style={{ marginTop: 10, fontSize: 12, color: "#888", display: "flex", flexWrap: "wrap", gap: 16 }}>
                  {material.procesos && <span>Procesos: {material.procesos}</span>}
                  {material.calibre && <span>Calibre: {material.calibre}</span>}
                  {material.dimensiones && <span>Dimensiones: {material.dimensiones}</span>}
                  {material.cantidad && <span>Cantidad: {material.cantidad}</span>}
                  {material.cantidadPiezas !== undefined && material.cantidadPiezas !== null && (
                    <span>Piezas: {material.cantidadPiezas}</span>
                  )}
                  {material.fechaAvance && (
                    <Tooltip title="Último movimiento de avance">
                      <span>Movido: {moment(material.fechaAvance).format("DD/MM/YYYY HH:mm")}</span>
                    </Tooltip>
                  )}
                </div>
              </DynamicCardForm>
            ))}

            <DynamicCardForm title="Historial" marginBottom={8} compact>
              {(ordenDeMaquila.seguimiento || []).length === 0 ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin movimientos" />
              ) : (
                <Timeline style={{ marginTop: 8 }}>
                  {[...(ordenDeMaquila.seguimiento || [])]
                    .reverse()
                    .map((movimiento, indice) => (
                      <Timeline.Item key={indice} color={COLOR_PUNTO[movimiento.tipo] || "blue"}>
                        <div style={{ fontSize: 13 }}>
                          {movimiento.material && <strong>{movimiento.material}: </strong>}
                          {movimiento.de && movimiento.a
                            ? `${movimiento.de} → ${movimiento.a}`
                            : movimiento.comentario || movimiento.tipo}
                        </div>
                        <div style={{ fontSize: 11.5, color: "#999" }}>
                          {moment(movimiento.fecha).format("DD/MM/YYYY HH:mm")}
                          {movimiento.usuarioNombre ? ` · ${movimiento.usuarioNombre}` : ""}
                        </div>
                      </Timeline.Item>
                    ))}
                </Timeline>
              )}
            </DynamicCardForm>
          </>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(SeguimientoOrdenDeMaquila);
